import { ElInput } from 'element-plus'
import { defineComponent, h, ref, watch } from 'vue'

function formatWithCommas(value) {
  if (value === undefined || value === null || value === '') return ''
  const num = typeof value === 'number' ? value : parseFloat(String(value).replace(/,/g, ''))
  if (isNaN(num)) return ''
  return num.toLocaleString('en-UK')
}

function parseNumber(value) {
  if (value === undefined || value === null || value === '') return NaN
  return parseFloat(String(value).replace(/,/g, ''))
}

export default defineComponent({
  props: {
    context: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const rawValue = ref(formatWithCommas(props.context._value))

    watch(
      () => props.context._value,
      (newVal) => {
        rawValue.value = formatWithCommas(newVal)
      },
    )

    const onInput = (val) => {
      const num = parseNumber(val)

      if (!isNaN(num)) {
        let clamped = num

        const min = parseFloat(props.context.attrs?.min)
        const max = parseFloat(props.context.attrs?.max)

        if (!isNaN(min)) clamped = Math.max(clamped, min)
        if (!isNaN(max)) clamped = Math.min(clamped, max)

        props.context.handlers.DOMInput({ target: { value: clamped } })
      } else {
        props.context.handlers.DOMInput({ target: { value: '' } })
      }

      rawValue.value = val
    }

    const onBlur = () => {
      const num = parseNumber(rawValue.value)
      rawValue.value = isNaN(num) ? '' : formatWithCommas(num)
      props.context.handlers.blur()
    }

    return () =>
      h(
        ElInput,
        Object.assign({}, props.context, props.context.attrs, {
          modelValue: rawValue.value,
          type: 'text',
          disabled: props.context.disabled,
          'onUpdate:modelValue': onInput,
          onBlur,
        }),
        {
          prepend: h('span', '£'),
        },
      )
  },
})
